export type PrometheusValkeyBlockedClientsStatsBackendApiProps = {
    created: number;
    blocked_clients: number;
};

export default class PrometheusValkeyBlockedClientsStats {
    readonly created: number;
    readonly blockedClients: number;

    constructor(props: PrometheusValkeyBlockedClientsStatsBackendApiProps) {
        this.created = props.created;
        this.blockedClients = props.blocked_clients;
    }
}
